import React, { useState, useEffect } from "react";
import "./bank-save-model.css";
import { Spinner } from "react-bootstrap";
import { submitContactAPI, updateContactAPI } from "./vendor_api";

const initialState = {
  contact_id: "",
  title: "",
  name: "",
  mobile: "",
  email: "",
  vendor_notify: true,
};

const ContactModal = ({ onClose, onSuccess, vendorId, contact }) => {
  const [form, setForm] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const handleChange = (key, value) => {
    if (key === "mobile") {
      const numericValue = value.replace(/\D/g, "");
      if (numericValue.length > 10) return;
      setForm((prev) => ({ ...prev, [key]: numericValue }));
      setErrors((prev) => ({ ...prev, [key]: "" }));
      return;
    }
    setForm((prev) => ({ ...prev, [key]: value }));
    setErrors((prev) => ({ ...prev, [key]: "" }));
  };
  useEffect(() => {
    if (contact) {
      setForm({
        contact_id: contact.id || "",
        title: contact.title || "",
        name: contact.name || "",
        email: contact.email || "",
        mobile: contact.mobile || contact.phone || "",
        vendor_notify: contact.vendor_notify ?? false,
      });
    }
  }, [contact]);

  const handleSave = async () => {
    if (form.mobile && form.mobile.length < 10) {
      setErrors((prev) => ({ ...prev, mobile: "Mobile number must be 10 digits" }));
      return;
    }
    try {
      setSaving(true);

      const apiCall = contact ? updateContactAPI : submitContactAPI;

      const response = await apiCall(vendorId, form);

      if (response?.data?.success) onSuccess(response);
      else setErrors(response?.data?.errors ?? {});
    } catch (err) {
      console.error("Save failed:", err);
    } finally {
      setSaving(false);
    }
  };

  const renderInput = (label, key, type = "text") => (
    <div className="form-group">
      <div className="input-label">
        {label}
        <span className="error-text">*</span>
      </div>

      <input
        type={type}
        className="form-control rounded-3 vendor-form-input"
        placeholder="Enter here..."
        value={form[key]}
        onChange={(e) => handleChange(key, e.target.value)}
      />

      {errors[key] && <span className="error-text">{errors[key]}</span>}
    </div>
  );

  return (
    <div className="modal-overlay">
      <div className="modal-card" style={{ width: "600px" }}>
        <div className="modal-header">
          <h3>{contact ? "Edit contact" : "New contact"}</h3>
          <button className="close-btn" onClick={onClose}>
            ✕
          </button>
        </div>

        <div>
          {renderInput("Title", "title")}

          <div className="mt-2 two-column">
            {renderInput("Name", "name")}
            {renderInput("Mobile number", "mobile")}
          </div>

          <div className="form-group">
            <div className="input-label">
              Email
              <span className="error-text">*</span>
            </div>
            <div className="email-notify-row">
              <div className="w-100">
                <input
                  type="email"
                  className="form-control rounded-3 vendor-form-input"
                  placeholder="Enter here..."
                  value={form.email}
                  onChange={(e) => handleChange("email", e.target.value)}
                />
                {errors.email && (
                  <span className="error-text">{errors.email}</span>
                )}
              </div>

              <div
                className="notify-pill"
                onClick={() =>
                  handleChange("vendor_notify", !form.vendor_notify)
                }
              >
                <input type="checkbox" checked={form.vendor_notify} readOnly />
                <span className="custom-check"></span>
                <span className="notify-text">Notify</span>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="cancel-new-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            className="contact-new-btn"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? <Spinner animation="border" size="sm" /> : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
